import { getResourceStore } from '../resource-store';
export const addResourcesListener = fn => getResourceStore().storeState.subscribe(fn);